import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "search-card-footer" }
const _hoisted_2 = { class: "search-card-footer-price" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "search-card-footer-price__text" }, [
  /*#__PURE__*/_createTextVNode(" Такса RI: "),
  /*#__PURE__*/_createVNode("b", null, "101 000 ₽"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createVNode("span", null, "*Без НДС")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "search-card-footer-price__text" }, [
  /*#__PURE__*/_createTextVNode(" Такса RI: "),
  /*#__PURE__*/_createVNode("b", null, "101 000 ₽"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createVNode("span", null, "*Без НДС")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "search-card-footer-price__text"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" ИТОГ: ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "*Без НДС", -1)
const _hoisted_9 = {
  key: 1,
  class: "search-card-footer-price__text"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" ИТОГ: ")
const _hoisted_11 = /*#__PURE__*/_createVNode("b", null, "101 000 ₽", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode()
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "*Без НДС", -1)
const _hoisted_14 = { class: "search-card-footer-controls" }
const _hoisted_15 = /*#__PURE__*/_createVNode("button", { class: "search-card-footer-controls__dropdown" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.showPrice)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _hoisted_3,
            _hoisted_4,
            (_ctx.item && _ctx.item.comparisionPrice)
              ? (_openBlock(), _createBlock("p", _hoisted_5, [
                  _hoisted_6,
                  _createVNode("b", null, _toDisplayString(_ctx.item.comparisionPrice), 1),
                  _hoisted_7,
                  _hoisted_8
                ]))
              : (_openBlock(), _createBlock("p", _hoisted_9, [
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13
                ]))
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_14, [
      _hoisted_15,
      (!_ctx.isSelected)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            class: "search-card-footer-controls__submit",
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.toggleDisplay(_ctx.item && _ctx.item.accessKey ? _ctx.item.accessKey : null)))
          }, " Выбрать "))
        : _createCommentVNode("", true),
      (_ctx.isSelected)
        ? (_openBlock(), _createBlock("button", {
            key: 1,
            class: "search-card-footer-controls__submit",
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.toggleDisplay(_ctx.item && _ctx.item.accessKey ? _ctx.item.accessKey : null)))
          }, " Изменить "))
        : _createCommentVNode("", true)
    ])
  ]))
}